<template>
  <div
    v-if="permissionIsAssigned('recruitment-read') || userType == 1"
    class="tab-pane fade"
    id="list-settings-recruitment"
    role="tabpanel"
    aria-labelledby="list-settings-recruitment-list"
  >
    <div v-if="create_stage_form">
      <h4>
        <div class="row">
          <div class="col-lg-6" style="align-self: center;">
            {{
              create_stage_form
                ? 'Create Interview Stage'
                : 'All Interview Stages'
            }}
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div
                v-if="create_stage_form"
                class="col-lg-3 offset-9 py-4 text-right"
              >
                <button
                  @click="create_stage_form = false"
                  style="float: right; background: linear-gradient(45deg, #dc3545, #c82333); border: none; box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3); transition: all 0.3s ease;"
                  type="button"
                  class="btn btn-sm m-1 text-white btn-raised ripple"
                  onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 6px 12px rgba(220, 53, 69, 0.4)'"
                  onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 4px 8px rgba(220, 53, 69, 0.3)'"
                >
                  <i class="fal fa-times mr-2"></i>Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </h4>
      <div class="main-content mt-0 px-0">
        <div>
          <v-form @submit.prevent>
            <div class="container-fluid">
              <v-row>
                <v-col cols="12" sm="6" md="6" class="remove-hint">
                  <span style="color: #111d5e;"
                    >Stage Name
                    <i
                      class="fal fa-asterisk"
                      style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"
                    ></i
                  ></span>
                  <v-text-field
                    v-model="stage_form.stage_name"
                    placeholder="Enter the stage name"
                    solo
                    class="mt-2"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="remove-hint">
                  <span style="color: #111d5e;"
                    >Description
                    <i
                      class="fal fa-asterisk"
                      style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"
                    ></i
                  ></span>
                  <v-text-field
                    v-model="stage_form.description"
                    placeholder="Enter the stage description"
                    solo
                    class="mt-2"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  offset-md="3"
                  class="remove-hint"
                >
                  <button
                    @click="create_stage_submit ? null : create_stage()"
                    style="width: 99%; background: linear-gradient(45deg, #069, #0066cc); border: none; box-shadow: 0 4px 8px rgba(6, 105, 153, 0.3); transition: all 0.3s ease;"
                    type="button"
                    class="btn m-1 text-white btn-raised ripple"
                    onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 6px 12px rgba(6, 105, 153, 0.4)'"
                    onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 4px 8px rgba(6, 105, 153, 0.3)'"
                  >
                    <i class="fal fa-save mr-2"></i>{{ create_stage_text }}
                    <v-icon
                      :style="
                        !create_stage_submit
                          ? 'display: none;'
                          : 'color: #fff; padding: 0px 10px; font-size: 16px;'
                      "
                    >
                      fal fa-circle-notch fa-spin
                    </v-icon>
                  </button>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </div>
      </div>
    </div>
    <div v-else>
      <h4>
        <div class="row">
          <div class="col-lg-6" style="align-self: center;">
            Interview Stages Management
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-3 offset-9 py-4">
                <button
                  v-if="
                    permissionIsAssigned('recruitment-create') || userType == 1
                  "
                  @click="create_stage_form = true"
                  style="float: right; background: linear-gradient(45deg, #069, #0066cc); border: none; box-shadow: 0 4px 8px rgba(6, 105, 105, 0.3); transition: all 0.3s ease;"
                  type="button"
                  class="btn btn-sm m-1 text-white btn-raised ripple"
                  onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 6px 12px rgba(6, 105, 105, 0.4)'"
                  onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 4px 8px rgba(6, 105, 105, 0.3)'"
                >
                  <i class="fal fa-plus mr-2"></i>Create Interview Stage
                </button>
              </div>
            </div>
          </div>
        </div>
      </h4>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-left">
                Stage Name
              </th>
              <th scope="col" class="text-left">
                Description
              </th>
              <th scope="col" class="text-left">
                Created Date
              </th>
              <th
                v-if="
                  permissionIsAssigned('recruitment-update') ||
                    permissionIsAssigned('recruitment-delete') ||
                    userType == 1
                "
                scope="col"
                style="width: 10px;"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="stage in interview_stages" :key="stage.id">
              <td class="text-left">
                {{ stage.stage_name }}
              </td>
              <td class="text-left">{{ stage.description }}</td>
              <td class="text-left">{{ formatDate(stage.created_at) }}</td>
              <td
                v-if="
                  permissionIsAssigned('recruitment-update') ||
                    permissionIsAssigned('recruitment-delete') ||
                    userType == 1
                "
                style="padding-top: 13px;"
                class="employee-options"
              >
                <div class="row">
                  <div class="action-icons">
                    <i
                      v-if="
                        permissionIsAssigned('recruitment-update') ||
                          userType == 1
                      "
                      class="fal fa-edit action-icon edit"
                      @click="launch_edit_stage(stage)"
                      title="Edit Stage"
                    ></i>
                    <i
                      v-if="
                        permissionIsAssigned('recruitment-delete') ||
                          userType == 1
                      "
                      class="fal fa-trash action-icon delete"
                      @click="delete_stage(stage)"
                      title="Delete Stage"
                    ></i>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <v-dialog v-model="stage_edit_dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ 'Edit Interview Stage' }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form @submit.prevent>
              <div class="container-fluid">
                <v-row>
                  <v-col cols="12" sm="6" md="6" class="remove-hint">
                    <v-text-field
                      dense
                      v-model="edit_stage_form.stage_name"
                      placeholder="Stage Name"
                      solo
                      class="mt-2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="remove-hint">
                    <v-text-field
                      dense
                      v-model="edit_stage_form.description"
                      placeholder="Description"
                      solo
                      class="mt-2"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                    offset-md="3"
                    offset-sm="3"
                    class="remove-hint"
                  >
                    <button
                      @click="edit_stage_submit ? null : update_stage()"
                      style="width: 100%; background: linear-gradient(45deg, #069, #0066cc); border: none; box-shadow: 0 4px 8px rgba(6, 105, 153, 0.3); transition: all 0.3s ease;"
                      type="button"
                      class="btn m-1 text-white btn-raised ripple"
                      onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 6px 12px rgba(6, 105, 153, 0.4)'"
                      onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 4px 8px rgba(6, 105, 153, 0.3)'"
                    >
                      <i class="fal fa-edit mr-2"></i>{{ edit_stage_text }}
                      <v-icon
                        :style="
                          !edit_stage_submit
                            ? 'display: none;'
                            : 'color: #fff; padding: 0px 10px; font-size: 16px;'
                        "
                      >
                        fal fa-circle-notch fa-spin
                      </v-icon>
                    </button>
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="stage_edit_dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      create_stage_form: false,
      stage_form: {
        stage_name: '',
        description: '',
      },
      edit_stage_form: {
        id: null,
        stage_name: '',
        description: '',
      },
      edit_stage_text: 'Update',
      edit_stage_submit: false,
      create_stage_text: 'Submit',
      create_stage_submit: false,
      stage_edit_dialog: false,
      interview_stages: [],
    };
  },
  computed: {
    ...mapGetters(['authCompanyData', 'userType']),
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
    fetch_interview_stages() {
      const _this = this;
      const token = localStorage.getItem('userToken');

      console.log(
        'Token being used:',
        token ? 'Token exists' : 'No token found'
      );
      console.log('Full token:', token);

      window.axios
        .get(`https://apiqa.kylianerp.com/api/interviewstages`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(function(response) {
          console.log('Success response:', response);
          _this.interview_stages = response.data.data || [];
        })
        .catch(function(error) {
          console.log('Error fetching interview stages:', error);
          console.log('Error response:', error.response);
          console.log('Error status:', error.response?.status);
          console.log('Error data:', error.response?.data);

          _this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: `Failed to fetch interview stages: ${
              error.response?.status
            } - ${error.response?.data?.message || error.message}`,
          });
        });
    },
    create_stage() {
      const _this = this;
      _this.create_stage_text = '';
      _this.create_stage_submit = true;

      if (!_this.stage_form.stage_name || !_this.stage_form.stage_name.trim()) {
        const Toast = _this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', _this.$swal.stopTimer);
            toast.addEventListener('mouseleave', _this.$swal.resumeTimer);
          },
        });
        Toast.fire({ icon: 'error', title: 'Stage name is required' });
        _this.create_stage_submit = false;
        _this.create_stage_text = 'Submit';
        return;
      }

      const Toast = _this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', _this.$swal.stopTimer);
          toast.addEventListener('mouseleave', _this.$swal.resumeTimer);
        },
      });

      const formData = new FormData();
      formData.append('stage_name', _this.stage_form.stage_name);
      formData.append('description', _this.stage_form.description);

      window.axios
        .post(`https://apiqa.kylianerp.com/api/interviewstages`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(function() {
          Toast.fire({
            icon: 'success',
            title: _this.stage_form.stage_name + ' was added successfully',
          });
          _this.stage_form.stage_name = '';
          _this.stage_form.description = '';
          _this.fetch_interview_stages();
          _this.create_stage_form = false;
        })
        .catch(function(error) {
          let errors =
            error.response?.data?.errors || error.response?.data?.error || null;
          Toast.fire({
            icon: 'error',
            title: errors
              ? typeof errors === 'string'
                ? errors
                : null ||
                  (errors.stage_name ? errors.stage_name[0] : null) ||
                  (errors.description ? errors.description[0] : null)
              : null ||
                error.response?.data?.error ||
                error.response?.data?.message ||
                'The interview stage could not be added',
          });
        })
        .then(function() {
          _this.create_stage_submit = false;
          _this.create_stage_text = 'Submit';
        });
    },
    launch_edit_stage(stage) {
      this.edit_stage_form.id = stage.id;
      this.edit_stage_form.stage_name = stage.stage_name;
      this.edit_stage_form.description = stage.description;
      this.stage_edit_dialog = true;
    },
    update_stage() {
      const _this = this;
      _this.edit_stage_text = '';
      _this.edit_stage_submit = true;

      if (
        !_this.edit_stage_form.stage_name ||
        !_this.edit_stage_form.stage_name.trim()
      ) {
        const Toast = _this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', _this.$swal.stopTimer);
            toast.addEventListener('mouseleave', _this.$swal.resumeTimer);
          },
        });
        Toast.fire({ icon: 'error', title: 'Stage name is required' });
        _this.edit_stage_submit = false;
        _this.edit_stage_text = 'Update';
        return;
      }

      const Toast = _this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', _this.$swal.stopTimer);
          toast.addEventListener('mouseleave', _this.$swal.resumeTimer);
        },
      });

      const payload = {
        stage_name: _this.edit_stage_form.stage_name,
        description: _this.edit_stage_form.description,
      };

      window.axios
        .put(
          `https://apiqa.kylianerp.com/api/interviewstages/${_this.edit_stage_form.id}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('userToken')}`,
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          }
        )
        .then(function() {
          Toast.fire({
            icon: 'success',
            title: 'The interview stage has been updated successfully',
          });
          _this.edit_stage_form.id = null;
          _this.edit_stage_form.stage_name = '';
          _this.edit_stage_form.description = '';
          _this.fetch_interview_stages();
          _this.stage_edit_dialog = false;
        })
        .catch(function(error) {
          let errors =
            error.response?.data?.errors || error.response?.data?.error || null;
          Toast.fire({
            icon: 'error',
            title: errors
              ? typeof errors === 'string'
                ? errors
                : null ||
                  (errors.stage_name ? errors.stage_name[0] : null) ||
                  (errors.description ? errors.description[0] : null)
              : null ||
                error.response?.data?.error ||
                error.response?.data?.message ||
                "The interview stage couldn't be updated",
          });
        })
        .then(function() {
          _this.edit_stage_submit = false;
          _this.edit_stage_text = 'Update';
        });
    },
    delete_stage(stage) {
      const _this = this;
      const Toast = _this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', _this.$swal.stopTimer);
          toast.addEventListener('mouseleave', _this.$swal.resumeTimer);
        },
      });

      _this.$swal
        .fire({
          title:
            'Are you sure you want to delete this interview stage [' +
            stage.stage_name +
            ']?',
          showCancelButton: true,
          confirmButtonText: `Yes, Delete`,
        })
        .then((result) => {
          if (result.isConfirmed) {
            window.axios
              .delete(
                `https://apiqa.kylianerp.com/api/interviewstages/${stage.id}`,
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                      'userToken'
                    )}`,
                  },
                }
              )
              .then(function() {
                Toast.fire({
                  icon: 'success',
                  title:
                    'Interview Stage [' +
                    stage.stage_name +
                    '] deleted successfully',
                });
                _this.fetch_interview_stages();
              })
              .catch(function(error) {
                Toast.fire({
                  icon: 'error',
                  title:
                    'Interview Stage [' +
                    stage.stage_name +
                    "] couldn't be deleted",
                });
                console.log(error);
              });
          }
        });
    },
  },
  mounted() {
    this.fetch_interview_stages();
  },
};
</script>

<style>
.remove-hint .v-text-field__details {
  display: none !important;
}

/* Enhanced table styling */
.table {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.table thead th {
  background: linear-gradient(45deg, #069, #0066cc);
  color: white;
  border: none;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

.table tbody tr {
  transition: all 0.3s ease;
}

.table tbody tr:hover {
  background-color: #f8f9fa;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.table tbody td {
  border-color: #e9ecef;
  vertical-align: middle;
}

/* Form styling enhancements */
.v-text-field--solo .v-input__control {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.v-text-field--solo .v-input__control:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Card styling for edit dialog */
.v-card {
  border-radius: 15px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
}

.v-card__title {
  background: linear-gradient(45deg, #069, #0066cc);
  color: white;
  border-radius: 15px 15px 0 0 !important;
}

/* Button hover effects */
.btn {
  border-radius: 8px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.5px;
}

.btn:hover {
  transform: translateY(-2px);
}

.action-icons {
  display: flex;
  align-items: center;
  gap: 10px;
}

.action-icon {
  color: #069 !important;
  font-size: 115%;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  transition: background 0.2s ease;
}

.action-icon:hover {
  background: rgba(6, 105, 153, 0.1);
}

.action-icon.delete {
  color: #c82333 !important;
}

/* Loading animation enhancement */
.fa-spin {
  animation: fa-spin 1s infinite linear;
}

@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Responsive improvements */
@media (max-width: 768px) {
  .table-responsive {
    border-radius: 10px;
  }

  .btn {
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
  }
}
</style>
